import React, { useState } from "react";
import { Dialog, Popover } from "@mui/material";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
// import { subHeadingStyle } from "../../../studentFinanceApproval/epmrCancellation/constant";
import { ReactComponent as WarningIcon } from "assets/img/svg/Warning.svg"
import { subHeadingStyle } from "views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant";


export const WarningDialoge = (
 {setOpen,
  isOpen,
  title,
  handleOkay,
  subheading})=>{
    const handleClose=()=>{
      setOpen(false)
    }
    return <Dialog open={isOpen}  maxWidth ="md">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          {/* <QuestionMarkIcon /> */}
          <WarningIcon/>
          <CrossIcon onClick={handleClose} />
        </div>
        <div style={{width:'440px'}}>
        <div className="header">{title}</div>
        <div style={subHeadingStyle}>{subheading}</div>
        <div className="mt-4">
          <AButton
            variant="primary_filled"
            size='sm'
            onClick={() => {
             handleOkay?handleOkay(): handleClose()
            }}
          >
            Okay
          </AButton>
        </div>
            </div>
      </div>
    </Dialog>

     
};

export default WarningDialoge;
